import styled from "styled-components";

export const RetailMatchChartIndexPill = styled.div`
  color: rgb(255, 255, 255);
  border-radius: 50%;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 14px;
`;
